import React from 'react';

export const itemIndexTemplate = (index: number) => (
  <div className='flex items-center h-[64px]'>
    <div className='w-[2px] bg-bw05  h-full' />
    <span className='font-metricR text-[16px] text-bw07 text-center w-full'>{index + 1}</span>
  </div>
);
